module.exports = __webpack_public_path__ + "static/media/13.26167d05.png";